export default {
  productType: {
    Ok: 'Ok',
    Search: 'Search',
    Cancel: 'Cancel',
    TypeName: 'Type Name',
    OptionalAttribute: 'Optional Attribute',
    SuperiorTypeName: 'Superior Type Name',
    status: 'status',
    TypeDesc: 'Type Desc',
    CreateTime: 'Create Time',
    // 新增分类
    BasicInfo: 'Basic Info',
    SuperiorType: 'Superior Type',
    Desc: 'Desc',
    Picture: 'Picture',
    Specs: 'Specs',
    AddRow: 'AddRow',
    SpecName: 'Spec Name',
    ChooseSuperiorType: 'Choose Superior Type',
    ChooseProductType: 'Choose Product Type',
    Code: 'Code',
    Name: 'Name',
    PleaseEnterTypeName: 'Please Enter Type Name',
    SelectAtLeastOneAttribute: 'Select At Least One Attribute'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/pmc/productType.js